// one date/time formatter used everywhere.
//
// Replaces a variety of ad-hoc patterns like
//   new Date(Number(value)).toLocaleString()
//   new Intl.DateTimeFormat(undefined, {...}).format(new Date(value))
// with a small set of typed helpers. The formatters are memoized so we don't
// spin up a new Intl.DateTimeFormat on every render.

const absoluteFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "short",
});

const dateFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
});

const timeFormatter = new Intl.DateTimeFormat(undefined, {
  timeStyle: "short",
});

// Compact "Apr 18" — used for timeline tick labels where the year would be
// noisy.
const monthDayFormatter = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
});

function toDate(value) {
  if (value == null || value === "") return null;
  const ms = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(ms) || ms <= 0) return null;
  return new Date(ms);
}

// "Apr 18, 2026, 7:42 PM"
export function formatDate(value, fallback = "") {
  const date = toDate(value);
  return date ? absoluteFormatter.format(date) : fallback;
}

// "Apr 18, 2026"
export function formatDay(value, fallback = "") {
  const date = toDate(value);
  return date ? dateFormatter.format(date) : fallback;
}

// "7:42 PM"
export function formatTimeOnly(value, fallback = "") {
  const date = toDate(value);
  return date ? timeFormatter.format(date) : fallback;
}

// "Apr 18" — month + day only.
export function formatMonthDay(value, fallback = "") {
  const date = toDate(value);
  return date ? monthDayFormatter.format(date) : fallback;
}

// "just now", "12s ago", "3m ago", "2h ago", "4d ago"
export function formatRelative(value, fallback = "") {
  const date = toDate(value);
  if (!date) return fallback;

  const deltaMs = Date.now() - date.getTime();
  if (deltaMs < 5_000) return "just now";
  if (deltaMs < 60_000) return `${Math.floor(deltaMs / 1000)}s ago`;
  if (deltaMs < 3_600_000) return `${Math.floor(deltaMs / 60_000)}m ago`;
  if (deltaMs < 86_400_000) return `${Math.floor(deltaMs / 3_600_000)}h ago`;
  return `${Math.floor(deltaMs / 86_400_000)}d ago`;
}
